import elaLogo from '@/assets/images/elaLogo.png';
import klLogo from '@/assets/images/klLogo.png';

export const CONTENT_TYPE_PATH_MAPPING = {
  video: 'videos',
  image: 'figures',
  article: 'articles',
  audio: 'audios',
  music: 'audios',
  illustration: 'figures',
  worksheet: 'worksheets',
  educational_video: 'videos',
} as const;

export const APPLICATION_CODE_ROUTES: Record<string, string> = {
  expela: '/explore-ela',
  KL: '/knowledge-library',
} as const;

export const ROUTE_PRODUCT_MAPPING: Record<string, string> = {
  '/explore-ela': 'expela',
  '/knowledge-library': 'KL',
} as const;

export const CLASSES_TAB_PRODUCTS: string[] = ['expela'];

export const PRODUCT_SECTION_ROUTES: Record<string, string> = {
  expela: '/page',
  KL: '/pages',
} as const;

export const PRODUCT_SUBSECTION_ROUTES: Record<string, string> = {
  expela: '/part',
  KL: '/part',
} as const;

export const PRODUCT_BUNDLE_ROUTES: Record<string, string> = {
  expela: '/unit',
  KL: '/topic',
} as const;

export const PRODUCT_LANDING_PARAM_KEYS: Record<string, string> = {
  KL: 'grade',
} as const;

export const PRODUCT_LOGO_ALT_TEXT: Record<string, string> = {
  expela: 'Explore e-l-a',
  KL: 'Knowledge Library',
} as const;

export const PRODUCT_LOGO: Record<string, string> = {
  expela: elaLogo,
  KL: klLogo,
} as const;

export const PAGE_TYPE = {
  studentHistory: 'Student History',
  landingPage: 'Landing Page',
  packageSection: 'Package Section',
  assetFamily: 'Asset Family',
  standaloneAsset: 'Standalone Asset',
  bundle: 'Bundle',
} as const;

export const SITE_SECTION = {
  classes: 'Classes',
  data: 'Data and Insights',
  productExperience: 'Product Experience',
  subscriptions: 'Subscriptions',
  users: 'Users',
} as const;
